import get from 'lodash.get';

function getCategories(rootState) {
  return get(rootState, 'ws.template.meta.blockCategories', []);
}

export default getCategories;
